import Vue from 'vue'
import zh_CN from 'vee-validate/dist/locale/zh_CN.js';
import VeeValidate, { Validator } from 'vee-validate'
// 自定义提示
const dictionary = {
  zn: {
    messages: {
      required: (field) => '请输入' + field,
      max: () => '元素最大长度为20位'
    }
  }
}
Validator.localize('zh_CN', { messages: dictionary.zn.messages })
Validator.extend('phone', {
  getMessage: field => '请填写正确的手机号',
  validate: value => {
    return /^1[2|3|4|7|6|9|5|8]\d{9}$/.test(value)
  }
})
Validator.extend('money', {
  getMessage: field => '请填写正确的数字',
  validate: value => {
    return /(^[1-9]([0-9]+)?(\.[0-9]*)?$)|(^(0){1}$)|(^(0){1}\.[0-9]+$)/.test(value)
  }
})
Validator.extend('intNum', {
  getMessage: field => '请填写大于0的整数',
  validate: value => {
    let num = value + '';
    if (num.indexOf('.') > -1 || num == 0) {
      return false;
    } else {
      return true;
    }

  }
})

Validator.extend('companyPhone', {
  getMessage: field => field + '格式输入不正确',
  validate: value => {
    return /^(((\d{3,4})(-)?\d{7,8})|(1[3584]\d{9})|((\d{3})(-)?\d{3,4}(-)?\d{3,4})|(\d{5}))$/.test(value)
  }
})
Validator.extend('numTime', {
  getMessage: field => field + '为5-300的纯数字',
  validate: value => {
    if (4 < value && value < 301) {
      return /^[0-9]*$/.test(value);
    } else {
      return false;
    }

  }
})
Validator.extend('numCount', {
  getMessage: field => field + '为大于0的纯数字',
  validate: value => {
    if (0 < value) {
      return /^[0-9]*$/.test(value);
    } else {
      return false;
    }

  }
})
Validator.extend('password', {
  getMessage: field => '密码为8-20位大小写字母、数字、符号的至少三种组合',
  validate: value => {
    /*
        return /^(?![A-Za-z]+$)(?![A-Z\\d]+$)(?![A-Z\\W]+$)(?![a-z\\d]+$)(?![a-z\\W]+$)(?![\\d\\W]+$)\\S{8,20}$/.test(value)
    */
    return /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*,.?></]+$)(?![a-z\d]+$)(?![A-Z\d]+$)(?![a-z!@#$%^&*,.?></]+$)(?![\d!@#$%^&*,.?></]+$)(?![A-Z!@#$%^&*,.?></]+$)[a-zA-z\d!@#$%^&*,.?></]{8,20}$/.test(value)
  }
})
Validator.extend('name', {
  getMessage: field => '字母数字长度2至14位，汉字位数2至6位',
  validate: value => {
    return /^([\u4e00-\u9fa5]{2,6}|[a-zA-Z\d]{2,14})$/.test(value)
  }
})
Validator.extend('word', {
  getMessage: field => '只能输入字母，数字，汉字',
  validate: value => {
    return /[^\u4e00-\u9fa5]/.test(value)
  }
})
Validator.extend('email', {
  getMessage: field => '请填写正确的邮箱地址',
  validate: value => {
    return /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)
  }
});
Validator.extend('max50', {
  getMessage: field => field + '最大长度不能超过50',
  validate: value => {
    return /^.{0,50}$/.test(value)
  }
})
Validator.extend('max10', {
  getMessage: field => field + '最大长度不能超过10',
  validate: value => {
    return /^.{0,10}$/.test(value)
  }
})
Validator.extend('max20', {
  getMessage: field => field + '最大长度不能超过20',
  validate: value => {
    return /^.{0,20}$/.test(value)
  }
})
/*Validator.extend('max5', {
  getMessage: field => field+'最多填写5个',
  validate: value => {
    var a = value.split(',').length
    return a<=5
  }
})*/
Validator.extend('max30', {
  getMessage: field => field + '不能超过30个字符',
  validate: value => {
    return /^.{0,30}$/.test(value)
  }
})
Validator.extend('max70', {
  getMessage: field => field + '最大长度不能超过70',
  validate: value => {
    return /^.{0,70}$/.test(value)
  }
})
Validator.extend('max100', {
  getMessage: field => field + '最大长度不能超过100',
  validate: value => {
    return /^.{0,100}$/.test(value)
  }
})
Validator.extend('pwd', {
  getMessage: field => 'admin更名应为5-10位英文或数字',
  validate: value => {
    return /^\b\w{5,10}$/.test(value)
  }
})
Validator.extend('account', {
  getMessage: field => '请填写正确的银行账户（5-23位数字）',
  validate: value => {
    return /^[0-9]{5,23}$/.test(value)
  }
})
Validator.extend('ip', {
  getMessage: field => '请填写正确的IP地址',
  validate: value => {
    return /^(((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))(:\d+)?)(,(((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))(:\d+)?))*$/.test(value)
  }
})
Validator.extend('ip2', {
  getMessage: field => '请填写正确的IP地址',
  validate: value => {
    return /^(((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))(\/\d+)?)(,(((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))(\/\d+)?))*$/.test(value)
  }
})
Validator.extend('wf', {
  getMessage: field => '请填写正确的网关地址',
  validate: value => {
    return /^(?:(?:^|,)(?:[0-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])(?:\.(?:[0-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])){3})+(\/\d{2})?$/.test(value)
  }
})
Validator.extend('portMax', {
  getMessage: field => '端口号最大不超过65536',
  validate: value => {
    value = parseInt(value)
    return value < 65536
  }
})
Validator.extend('timeMax', {
  getMessage: field => '请填写1至72之间的数字',
  validate: value => {
    value = parseInt(value)
    return value <= 72 && value > 0
  }
})
Validator.extend('numberMax', {
  getMessage: field => '请填写0至100的数字，不超过2位小数',
  validate: value => {
    return /^([0-9]{1,2}$)|(^[0-9]{1,2}\.[0-9]{1,2}$)|100$/.test(value)
  }
})
Validator.extend('port', {
  getMessage: field => '请填写正确的端口号',
  validate: value => {
    return /^(\d+?)(,(\d+?))*$/.test(value)
  }
})
Validator.extend('subnet', {
  getMessage: field => '请填写正确的子网掩码',
  validate: value => {
    return /^(254|252|248|240|224|192|128|0)\.0\.0\.0|255\.(254|252|248|240|224|192|128|0)\.0\.0|255\.255\.(254|252|248|240|224|192|128|0)\.0|255\.255\.255\.(254|252|248|240|224|192|128|0)$/.test(value)
  }
})
export default function () {
  Vue.use(VeeValidate, { locale: zh_CN })
}



// WEBPACK FOOTER //
// ./src/jvsit/common/validator.js